import {Children, isValidElement, ReactNode} from 'react';
import {ViewerSlideType} from './ViewerSlide';

export function getViewerSlides(children: ReactNode) {
  const childrenArray = Children.toArray(children);
  return childrenArray.filter(
    child => isValidElement(child) && child.type === ViewerSlideType
  );
}
